/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { InvoicesDto } from './invoices.dto';
import { InvoicesMapper } from './invoices.mapper';

@Injectable()
export class SupplierInvoicesRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getAll(): SlicedDataSource<InvoicesDto> {
    return this.createSlicedDataSourceGet(`/invoices`, arrayOf(InvoicesMapper));
  }

  delete(id: ID): Observable<InvoicesDto> {
    return this.httpDelete(`/invoices/${id}`, void 0, InvoicesMapper);
  }
}
